import React, { FC } from 'react';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

// components
import ConditionalWrapper from 'src/components/helpers/ConditionalWrapper';
import { Link } from 'src/components/Inputs';
import LazyImage from 'src/components/Image';

// helpers
import { optimizeImage } from 'src/lib/image-helpers';
import { Image as ImageProps } from './Image.types';

const Image: FC<ImageProps> = ({
  caption,
  url,
  classes,
  src,
  entryId,
  ...props
}) => {
  const inspectorProps = useContentfulInspectorMode({ entryId });
  return (
    <figure
      className={classes?.figureClassName}
      {...(entryId ? inspectorProps({ fieldId: 'image' }) : null)}
    >
      <ConditionalWrapper
        condition={url}
        wrapper={(children) => {
          return (
            <Link href={url}>
              <a>{children}</a>
            </Link>
          );
        }}
      >
        <LazyImage
          alt={props.alt}
          className={classes?.imgClassName}
          src={optimizeImage(src)}
          {...props}
        />
      </ConditionalWrapper>
      {caption && <figcaption dangerouslySetInnerHTML={{ __html: caption }} />}
    </figure>
  );
};

export default Image;
